import { computedFn } from 'mobx-utils/lib/computedFn';
import { createAppButton } from 'owa-command-ribbon';
import AccCheckmark from 'owa-fluent-icons-svg/lib/icons/AccessibilityCheckmarkRegular';
import type { RibbonControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import { getComposeRibbonId } from 'owa-compose-ribbon-utils/lib/utils/getComposeRibbonId';
import type EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import type AccCheckerViewState from 'owa-editor-acc-checker/lib/store/schema/AccCheckerViewState';
import { lazyCloseChecker, lazyOpenChecker } from 'owa-editor-acc-checker';
import { logCSAUserAction } from '../../utils/logUserAction';
import type { IButtonStyles } from '@fluentui/react';
import { ActionControlId } from 'owa-ribbon-ids';
import loc from 'owa-localize';
import { accCheckerText } from '../../utils/actionControlStrings.locstring.json';
import { getHoverTooltip } from '../../utils/HoverTooltips/getHoverTooltip';
import { callEditorApi } from 'owa-editor/lib/utils/callEditorApi';

const onToggleAccChecker = (viewState: EditorViewState, accCheckerState: AccCheckerViewState) => {
    const key = 'AccChecker';

    return () => {
        if (viewState) {
            const targetWindow = callEditorApi(viewState, 'getDocument')?.defaultView || window;
            let dataPointSuffix = '';
            if (accCheckerState.isOpen) {
                dataPointSuffix = 'Close';
                lazyCloseChecker
                    .import()
                    .then(closeChecker => closeChecker(accCheckerState, targetWindow));
            } else {
                dataPointSuffix = 'Open';
                lazyOpenChecker
                    .import()
                    .then(openChecker => openChecker(accCheckerState, viewState, targetWindow));
            }
            logCSAUserAction(key, { key }, dataPointSuffix);
        }
    };
};

export const getAccChecker = computedFn(
    (
        viewState: EditorViewState,
        accCheckerState: AccCheckerViewState,
        styles: IButtonStyles | undefined
    ): RibbonControlProps => {
        const label = loc(accCheckerText);
        return createAppButton(
            getComposeRibbonId(ActionControlId.CheckForAccessibilityIssues, viewState),
            label,
            onToggleAccChecker(viewState, accCheckerState),
            undefined /* keytipProps */,
            AccCheckmark,
            undefined /* iconColor */,
            styles,
            {
                customTooltip: getHoverTooltip(ActionControlId.CheckForAccessibilityIssues, label),
            }
        );
    }
);
